<template>
  <p class="clearfix mb-0 text-center">
    

    <span class="d-md-block">© {{ current_year }} {{ appName }} | Powered by Evacovation</span>
  </p>
</template>

<script>
import { BLink } from "bootstrap-vue";
import { $themeConfig } from "@themeConfig";


export default {
  components: {
    BLink,    
  },
  data(){
    return{
      appName : "",
    }
  },
  created(){
    this.appName = $themeConfig.app.appName;
    this.current_year = new Date().getFullYear();
  }
  
};
</script>
